export default __webpack_public_path__ + "static/after-support-thumbnail-third-010f5197633edc7e867a807fbbe342d8.avif";